import React from "react";
import { SettingRow } from "../setting-row/setting-row";
import { PhotosGrid } from "../photos-grid/photos-grid";

export const PhotosSetting = ({
  myFiles,
  setMyFiles,
  setGlobalFiles,
  globalFiles,
  photosIsPending,
}) => {
  return (
    <SettingRow
      title="Фотографии для галереи"
      subtitle={
        <>
          Здесь вы можете добавить фотографии в галерею профиля
          <br />
          <br />
          Максимальное кол-во: 6<br />
          Максимальный размер: 3 мб
        </>
      }
    >
      <PhotosGrid
        {...{
          myFiles,
          setMyFiles,
          setGlobalFiles,
          globalFiles,
          photosIsPending,
        }}
      />
    </SettingRow>
  );
};
